var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import PropTypes from "prop-types";
export default (function (Screen, displayName, options) {
    if (options === void 0) { options = {}; }
    var ValidatedScreen = /** @class */ (function (_super) {
        __extends(ValidatedScreen, _super);
        function ValidatedScreen(props) {
            var _this = _super.call(this, props) || this;
            _this.state = {};
            return _this;
        }
        ValidatedScreen.prototype.getChildContext = function () {
            return {
                currentScreen: displayName
            };
        };
        ValidatedScreen.prototype.render = function () {
            var forwardedRef = this.props.forwardedRef;
            return React.createElement(Screen, __assign({}, this.props, { ref: forwardedRef }));
        };
        ValidatedScreen.navigationOptions = Screen.navigationOptions;
        ValidatedScreen.childContextTypes = {
            currentScreen: PropTypes.string.isRequired
        };
        return ValidatedScreen;
    }(Component));
    if (options.withRef) {
        return React.forwardRef(function (props, ref) {
            return React.createElement(ValidatedScreen, __assign({}, props, { forwardedRef: ref }));
        });
    }
    return ValidatedScreen;
});
